import asapLogo from "./assets/images/asap_logo.png";

// ============================================================
// ORIGINAL IMPORTS — commented out for maintenance page
// ============================================================
// import { useDispatch, useSelector } from "react-redux";
// import { Navigate, Route, Routes } from "react-router-dom";
// import "./App.css";
// import "./utils/antDStyles/customizedantdstyle.scss";
// import PageLayout from "./layouts/PageLayout";
// import ProtectedRoute from "./routes/ProtectedRoute";
// import Notification from "./shared/notification/Notification";
// import {
//   getnotificationdata,
//   notificationlist,
//   updatefirebasetoken,
//   updatenotificationcount,
// } from "./store/Common/CommonSlice";
// import { Suspense, lazy, useEffect } from "react";
// import { Skeleton, notification } from "antd";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import firebase from "./firebase";
// import { authtoken } from "./store/Authentication/AuthSlice";
// import AwbTrackingPage from "./components/User/TrackingComponent/TrackingDetail";
// const Login = lazy(() => import("./layouts/Login"));
// const LoginForm = lazy(() => import("./components/Authentication/LoginForm"));
// const SignupForm = lazy(() => import("./components/Authentication/SignupForm"));
// const ForgotPasswordForm = lazy(() =>
//   import("./components/Authentication/ForgotPasswordForm")
// );
// const ChangePasswordForm = lazy(() =>
//   import("./components/Authentication/ChangePasswordForm")
// );

// ============================================================
// ORIGINAL App FUNCTION — commented out for maintenance page
// ============================================================
// function App() {
//   const notificationData = useSelector(getnotificationdata);
//   const getauthtoken = useSelector(authtoken);
//   const dispatch = useDispatch();
//
//   const messaging = getMessaging();
//   onMessage(messaging, (payload) => {
//     dispatch(notificationlist(10))
//       .then((res) => {
//         if (res?.payload?.data?.statusCode === 200) {
//           dispatch(updatenotificationcount(res?.payload?.data?.newCount));
//           notification.open({
//             message: payload?.notification?.title,
//             description: payload?.notification?.body,
//             onClick: () => {
//               console.log("Notification Clicked!");
//             },
//           });
//         }
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//   });
//
//   useEffect(() => {
//     getToken(messaging, {
//       vapidKey:
//         "BA7TxqwNz4Er_lGHXZ-HmivAf-HTyCwamFjfAw7lIHjvERODTiY3gQS4-CZF9F_IhNixu8vDO1Nc1FaB5RqxXDg",
//     })
//       .then((currentToken) => {
//         if (currentToken) {
//           dispatch(updatefirebasetoken(currentToken));
//         } else {
//           console.log(
//             "No registration token available. Request permission to generate one."
//           );
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while retrieving token. ", err);
//       });
//   }, [messaging]);
//
//   return (
//     <>
//       <Routes>
//         <Route
//           path="/auth/*"
//           element={
//             <Suspense fallback={<Skeleton active />}>
//               <Login />
//             </Suspense>
//           }
//         >
//           <Route
//             path="login"
//             index
//             element={
//               <Suspense fallback={<Skeleton active />}>
//                 <LoginForm />
//               </Suspense>
//             }
//           />
//           <Route
//             path="signup"
//             element={
//               <Suspense fallback={<Skeleton active />}>
//                 <SignupForm />
//               </Suspense>
//             }
//           />
//           <Route
//             path="forgotpassword"
//             element={
//               <Suspense fallback={<Skeleton active />}>
//                 <ForgotPasswordForm />
//               </Suspense>
//             }
//           />
//           <Route
//             path="changepassword/:id/:token"
//             element={
//               <Suspense fallback={<Skeleton active />}>
//                 <ChangePasswordForm />
//               </Suspense>
//             }
//           />
//           <Route
//             path="updatepassword"
//             element={
//               <Suspense fallback={<Skeleton active />}>
//                 <ChangePasswordForm />
//               </Suspense>
//             }
//           />
//           <Route path="*" element={<Navigate to="login" replace />} />
//         </Route>
//         <Route
//           path="/*"
//           element={
//             <ProtectedRoute>
//               <PageLayout />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="track/:encodedAwbNumber"
//           element={
//             <Suspense fallback={<Skeleton active />}>
//               <AwbTrackingPage type="public" />
//             </Suspense>
//           }
//         />
//       </Routes>
//       {notificationData?.success && notificationData?.message && (
//         <>
//           <Notification notificationData={notificationData} />
//         </>
//       )}
//     </>
//   );
// }

const styles = {
  page: {
    height: "100vh",
    backgroundColor: "#111111",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "20px",
    boxSizing: "border-box",
    position: "relative",
    overflow: "hidden",
  },
  stripeOverlay: {
    position: "absolute",
    inset: 0,
    backgroundImage:
      "repeating-linear-gradient(45deg, transparent, transparent 40px, rgba(255,204,0,0.04) 40px, rgba(255,204,0,0.04) 80px)",
    pointerEvents: "none",
  },
  card: {
    backgroundColor: "#1a1a1a",
    border: "2px solid #FFCC00",
    borderRadius: "16px",
    padding: "36px 48px",
    maxWidth: "1100px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "48px",
    boxShadow: "0 0 60px rgba(255,204,0,0.15)",
    position: "relative",
    zIndex: 1,
    boxSizing: "border-box",
  },
  left: {
    flex: "0 0 340px",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  logo: {
    height: "64px",
    objectFit: "contain",
    marginBottom: "20px",
    filter: "drop-shadow(0 0 12px rgba(255,204,0,0.5))",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "#FFCC00",
    color: "#111111",
    fontWeight: "700",
    fontSize: "12px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    padding: "5px 14px",
    borderRadius: "20px",
    marginBottom: "16px",
  },
  dot: {
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    backgroundColor: "#111111",
    animation: "pulse 1.5s infinite",
  },
  heading: {
    fontSize: "34px",
    fontWeight: "800",
    color: "#FFCC00",
    margin: "0 0 10px",
    lineHeight: 1.2,
    letterSpacing: "-0.5px",
  },
  subheading: {
    fontSize: "14px",
    color: "#cccccc",
    margin: 0,
    lineHeight: 1.6,
  },
  divider: {
    width: "1px",
    alignSelf: "stretch",
    backgroundColor: "rgba(255,204,0,0.2)",
    border: "none",
    margin: 0,
    flexShrink: 0,
  },
  infoGrid: {
    flex: 1,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "14px",
  },
  infoCard: {
    backgroundColor: "#222222",
    border: "1px solid rgba(255,204,0,0.2)",
    borderRadius: "10px",
    padding: "16px 14px",
  },
  infoIcon: {
    fontSize: "20px",
    marginBottom: "6px",
  },
  infoTitle: {
    color: "#FFCC00",
    fontWeight: "700",
    fontSize: "12px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    marginBottom: "4px",
  },
  infoText: {
    color: "#aaaaaa",
    fontSize: "12px",
    lineHeight: 1.5,
  },
  footer: {
    color: "#555555",
    fontSize: "11px",
    marginTop: "16px",
    position: "relative",
    zIndex: 1,
  },
};

function App() {
  return (
    <div style={styles.page}>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.75); }
        }
      `}</style>
      <div style={styles.stripeOverlay} />

      <div style={styles.card}>
        {/* Left panel — logo + headline */}
        <div style={styles.left}>
          <img src={asapLogo} alt="ASAP Logo" style={styles.logo} />
          <div style={styles.badge}>
            <span style={styles.dot} />
            Under Construction
          </div>
          <h1 style={styles.heading}>We're Building<br />Something Great</h1>
          <p style={styles.subheading}>
            The ASAP Freight Platform is currently undergoing major upgrades.
            We'll be back online shortly with a better experience.
          </p>
        </div>

        {/* Vertical divider */}
        <hr style={styles.divider} />

        {/* Right panel — info cards */}
        <div style={styles.infoGrid}>
          <div style={styles.infoCard}>
            <div style={styles.infoIcon}>🚀</div>
            <div style={styles.infoTitle}>New Features</div>
            <div style={styles.infoText}>
              Enhanced rate search, live shipment tracking, and smarter freight tools.
            </div>
          </div>
          <div style={styles.infoCard}>
            <div style={styles.infoIcon}>🔒</div>
            <div style={styles.infoTitle}>Improved Security</div>
            <div style={styles.infoText}>
              Upgraded infrastructure and security protocols to protect your data.
            </div>
          </div>
          <div style={styles.infoCard}>
            <div style={styles.infoIcon}>⚡</div>
            <div style={styles.infoTitle}>Faster Performance</div>
            <div style={styles.infoText}>
              Optimized backend for blazing-fast load times across all modules.
            </div>
          </div>
          <div style={styles.infoCard}>
            <div style={styles.infoIcon}>📦</div>
            <div style={styles.infoTitle}>Better Tracking</div>
            <div style={styles.infoText}>
              Real-time AWB tracking with enhanced milestone visibility.
            </div>
          </div>
        </div>
      </div>

      <p style={styles.footer}>
        © {new Date().getFullYear()} ASAP Freight Solutions. All rights reserved.
      </p>
    </div>
  );
}

export default App;
